<template>
  <div class="textblock">
    <div class="hero is-primary">
      <div class="hero-body">
        <div class="container has-text-centered">
          <h1 class="title is-2 is-size-3-mobile">{{ headline }}</h1>
        </div>
      </div>
    </div>
    <div class="section is-medium">
      <div class="container">
        <div class="columns">
          <div class="column is-size-6 is-size-7-mobile">
            {{ column1 }}
            <br />
            <br />
            {{ column2 }}
          </div>
          <div class="column is-size-6 is-size-7-mobile">
            <figure class="image">
              <img
                sizes="(max-width: 7500px) 40vw, 3000px"
                srcset="../assets/images/Team-Wilde-Pracht-380.jpg  380w, ../assets/images/Team-Wilde-Pracht-440.jpg  440w, ../assets/images/Team-Wilde-Pracht-500.jpg  500w, ../assets/images/Team-Wilde-Pracht-560.jpg  560w, ../assets/images/Team-Wilde-Pracht-620.jpg  620w, ../assets/images/Team-Wilde-Pracht-680.jpg  680w, ../assets/images/Team-Wilde-Pracht-740.jpg  740w, ../assets/images/Team-Wilde-Pracht-800.jpg  800w, ../assets/images/Team-Wilde-Pracht-860.jpg  860w, ../assets/images/Team-Wilde-Pracht-920.jpg  920w, ../assets/images/Team-Wilde-Pracht-980.jpg  980w, ../assets/images/Team-Wilde-Pracht-1040.jpg 1040w, ../assets/images/Team-Wilde-Pracht-1100.jpg 1100w, ../assets/images/Team-Wilde-Pracht-1160.jpg 1160w, ../assets/images/Team-Wilde-Pracht-1220.jpg 1220w"
                src="../assets/images/Team-Wilde-Pracht-1220.jpg"
                alt="Gruppenfoto vom Team am Rande einer Fläche in der Blühsaison 2020."
              />
            </figure>
            <p class="smallspacetop">
              <b>Das ist das Team hinter der Wilden Pracht:</b>
              <br />Christian, Birte und Gunnar (v.l.) am Rande einer Fläche in der Blühsaison 2020.
            </p>
          </div>
        </div>
        <presslogo />
      </div>
    </div>
  </div>
</template>

<script>
import Presslogo from "@/components/Presslogo.vue";
export default {
  name: "Textblock",
  components: {
    Presslogo
  },
  props: {
    headline: String,
    column1: String,
    column2: String
  }
};
</script>

<style lang="scss"></style>
